import client from '@/api/base';

export default {
  // Demographics
  async getLeaderDemographics() {
    const response = await client.get('account/leader/demographics/');
    return response;
  },

  async postLeaderDemographics(data) {
    const response = await client.post('account/leader/demographics/', data);
    return response;
  },

  async patchLeaderDemographics(data) {
    const response = await client.patch('account/leader/demographics/', data);
    return response;
  },

  async resendLeaderInvitation(id) {
    const response = await client.post(`account/user/invite/${id}/re-invite/`);
    return response;
  },

  async resendLeaderInvitationOa(team, id) {
    const response = await client.post(`account/oa/org/${team}/invite/${id}/re-invite/`);
    return response;
  },
};
